import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

export const columns: Column[] = [
	{
		key: 'Physician',
		label: 'Provider',
		width: '150px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'Patient',
		label: 'Patient',
		width: '150px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'DateofService',
		label: 'Date of Service',
		width: '120px',
		type: 'date',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'TissueID',
		label: 'Tissue ID',
		width: '200px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'Product',
		label: 'Product',
		width: '200px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'Size',
		label: 'Size',
		width: '120px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'action',
		label: 'Action',
		width: '90px',
		type: 'string',
		sorter: false,
		hideColumnFilter: true,
		skipExport: true,
		hideFilterBy: true,
	},
];

export const transformedTableData = [
	{
		'provider.fullname': 'Dr. Emily Carter',
		'patient.fullname': 'John Doe',
		ta_proceduredate: '2025-10-28T00:00:00Z',
		'priorAuths.ta_name': 'TIS-0001',
		ta_portalbvupload: 'Revive Cleanser 8oz',
		'account.name': 'Medium',
		assign: '',
	},
	{
		'provider.fullname': 'Dr. Michael Thompson',
		'patient.fullname': 'Jane Smith',
		ta_proceduredate: '2025-10-27T00:00:00Z',
		'priorAuths.ta_name': 'TIS-0002',
		ta_portalbvupload: 'Hydrocolloid Dressing',
		'account.name': 'Large',
		assign: '',
	},
	{
		'provider.fullname': 'Dr. Olivia Nguyen',
		'patient.fullname': 'Robert Johnson',
		ta_proceduredate: '2025-10-25T00:00:00Z',
		'priorAuths.ta_name': 'TIS-0003',
		ta_portalbvupload: 'Foam Dressing 4x4',
		'account.name': 'Small',
		assign: '',
	},
	{
		'provider.fullname': 'Dr. Ethan Patel',
		'patient.fullname': 'Sarah Williams',
		ta_proceduredate: '2025-10-22T00:00:00Z',
		'priorAuths.ta_name': 'TIS-0004',
		ta_portalbvupload: 'Antimicrobial Gel',
		'account.name': 'Extra Large',
		assign: '',
	},
	{
		'provider.fullname': 'Dr. Sophia Kim',
		'patient.fullname': 'David Brown',
		ta_proceduredate: '2025-10-20T00:00:00Z',
		'priorAuths.ta_name': 'TIS-0005',
		ta_portalbvupload: 'Alginate Dressing',
		'account.name': 'Medium',
		assign: '',
	},
];
